exports.UINT32 = require('./lib/uint32')
exports.UINT64 = require('./lib/uint64')


//////////////////
// WEBPACK FOOTER
// ./node_modules/cuint/index.js
// module id = S1/o
// module chunks = 0